import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      // name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: "里数"
          }
        },
        {
          path: "/software",
          name: "software",
          component: resolve => require(["@/view/Software"], resolve),
          meta: {
            title: "解决方案"
          },
          children: [
            {
              path: "/software",
              redirect: "/solution/fasion"
            },
            {
              path: "/solution/fasion",
              name: "fasion",
              component: resolve =>
                require(["@/view/Software_smartTown"], resolve),
              meta: {
                title: "里数 解决方案丨智慧医疗与大健康方案"
              }
            },
            {
              path: "/solution/manufacturing",
              name: "manufacturing",
              component: resolve =>
                require(["@/view/Software_bigData"], resolve),
              meta: {
                title: "里数 解决方案丨智能制造与工业互联网"
              }
            }
          ]
        },
        {
          path: "/productCenter",
          name: "productCenter",
          component: resolve => require(["@/view/Service"], resolve),
          meta: {
            title: "里数 产品中心"
          }
        },
        {
          path: "/news",
          name: "news",
          component: resolve => require(["@/view/News"], resolve),
          meta: {
            title: "里数 新闻动态"
          }
        },
        {
          path: "/customerCase",
          name: "customerCase",
          component: resolve => require(["@/view/NewsInformation"], resolve),
          meta: {
            title: "里数 客户故事"
          }
        },
        {
          path: "/aboutUs",
          name: "aboutUs",
          component: resolve =>
            require(["@/view/CompanyIntroduction"], resolve),
          meta: {
            title: "里数 关于我们"
          }
        },
        {
          path: "/job",
          name: "job",
          component: resolve => require(["@/view/JobChance"], resolve),
          meta: {
            title: "里数 人才招聘"
          }
        },
        {
          path: "/contactus",
          name: "contactus",
          component: resolve => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "里数 人才招聘"
          }
        },
        {
          path: "/servicedetail",
          name: "servicedetail",
          component: resolve => require(["@/view/ServiceDetail"], resolve),
          meta: {
            title: "里数"
          }
        },
        {
          path: "/detail",
          name: "detail",
          component: resolve => require(["@/view/NewsDetail"], resolve),
          meta: {
            title: "里数"
          }
        }
      ]
    }
  ],
  mode: "history"
});



// WEBPACK FOOTER //
// ./src/router/index.js